<script setup>

import SelectInput from "@/components/global-themed/inputs/SelectInput.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {useStore} from "vuex";
import {ref} from "vue";
import BaseModal from "@/components/global-themed/BaseModal.vue";
import useHealthcheckStore from "@/composables/backlinks/useHealthcheckStore";
import SearchInput from "@/components/global-themed/SearchInput.vue";

const store = useStore();

const { search, maxDomainAuthority } = useHealthcheckStore();
const modalOpen = ref(false);

const handleProceed = () => {
  window.mixpanel('Backlink Healthcheck: Upload disavow list');
}

const onSearchInput = (value) => {
  store.dispatch('backlinkHealthcheck/setSearch', value);
}
</script>

<template>
  <div class="tw-grid tw-grid-cols-12 tw-gap-4 tw-items-end tw-py-8">
    <div
      class="tw-col-span-2"
    >
      <label for="maxDomainAuthority">Max Domain Authority</label>
      <SelectInput
        id="maxDomainAuthority"
        @input="(e) => store.dispatch('backlinkHealthcheck/setDomainAuthority', parseInt(e.target.value))"
      >
        <option
          v-for="value in 10"
          :key="value"
          :value="value"
          :selected="maxDomainAuthority === value"
        >
          {{ value }}
        </option>
      </SelectInput>
    </div>

    <div class="tw-col-span-4">
      <SearchInput
        v-model="search"
        placeholder="Search Backlink"
        @update:model-value="onSearchInput"
      />
    </div>

    <div class="tw-col-span-6 tw-flex tw-items-center tw-justify-end tw-gap-4">
      <DefaultButton
        variant="primary-inverted"
        as="a"
        class="py-2 px-4"
        href="/export/txt/disavow"
        size="small"
      >
        <span class="tw-font-semibold tw-antialiased">Export Disavow</span>
        <svg-vue
          icon="icons/download"
          class="tw-w-5 tw-h-5 tw-ml-2"
        />
      </DefaultButton>

      <DefaultButton
        variant="primary-inverted"
        target="_blank"
        class="py-2 px-4"
        size="small"
        @click.prevent="modalOpen = true"
      >
        <span class="tw-font-semibold tw-antialiased">Upload Disavow</span>
        <svg-vue
          icon="icons/upload"
          class="tw-w-5 tw-h-5 tw-ml-2"
        />
      </DefaultButton>

      <Teleport to=".tailwind">
        <BaseModal
          v-if="modalOpen"
          modal-class="tw-max-w-[800px]"
          @close="modalOpen = false"
        >
          <div class="tw-px-16 tw-pb-8 tw-flex tw-flex-col tw-gap-8 tw-justify-center">
            <h2 class="tw-text-2xl tw-text-center tw-font-medium">
              Wait! Before You Do This...
            </h2>
            <div class="tw-flex tw-flex-col tw-space-y-8 tw-text-lg">
              <p class="tw-text-grey-dark">
                Disavow files are <strong>very powerful</strong>. Before you upload this to Google make sure that you have not accidentally included any websites that you have deemed as non-harmful and you want to keep. If you accidentally disavow valuable backlinks this will have a harmful impact on your SEO.
              </p>
              <p class="tw-text-grey-dark">
                If this requires double, or even triple-checking, then we advise you do so. Once you are confident only harmful websites are included within your disavow file then proceed below.
              </p>
            </div>
            <div class="tw-w-auto tw-flex tw-space-x-8 tw-justify-end">
              <DefaultButton
                variant="base"
                @click="modalOpen = false"
              >
                Back
              </DefaultButton>
              <DefaultButton
                as="a"
                href="https://www.google.com/webmasters/tools/disavow-links-main"
                target="_blank"
                @click="handleProceed"
              >
                I understand and wish to proceed
              </DefaultButton>
            </div>
          </div>
        </BaseModal>
      </Teleport>
    </div>
  </div>
</template>

